import React from 'react';
import { RoadmapItem } from '@/models/RoadmapItem';
import './FollowButton.css';

interface FollowButtonProps {
    data: RoadmapItem;
    onFollow: (jiraId: string, isFollowed: boolean) => void;
    variant?: 'grid' | 'flyout';
}

const FollowButton: React.FC<FollowButtonProps> = ({ data, onFollow, variant = 'grid' }) => {
    const handleClick = (ev: React.MouseEvent) => {
        ev.stopPropagation();
        onFollow(data.jiraId, !data.isFollowed);
    };

    const buttonClass = variant === 'grid'
        ? 'follow-button follow-button-grid'
        : 'follow-button follow-button-flyout';

    return (
        <div className={buttonClass} onClick={handleClick}>
            {data.isFollowed ? 'Unfollow' : 'Follow'}
        </div>
    );
};

export default FollowButton;
